const API_URL = process.env.REACT_APP_API_URL || "https://bikeandride.chusdev.es"; 
console.log("API_URL =", API_URL); // para verificar
const env = { API_URL };
export default env;
